//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import catalogsFilter from '@/components/catalogsFilter.vue';
import searchCard from '@/components/searchCard.vue';
import { searchResourceByLabel, searchPluginByLabel } from '@/api/search';

export default {
  components: {
    catalogsFilter,
    searchCard
  },
  data() {
    return {
      searchVal: '',
      defaultChoosed: '',
      initServerData: {
        resourceList: [],
        pluginList: [],
        total: 0,
        plugin_total: 0,
      },
    };
  },
  computed: {
    tag_name() {
      return decodeURIComponent(this.$route.params.tag_name) || '';
    },
    cata_name() {
      return decodeURIComponent(this.$route.query.cata_name);
    },
  },
  created() {
    if (!['资源', '插件'].includes(this.cata_name)) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          cata_name: '资源',
        },
      });
    }
  },
  methods: {
    searchResource(searchVal) {
      if (!searchVal) return;
      this.searchVal = searchVal;
      this.$router.push({
        path: '/search',
        query: {
          searchVal,
          cata_name: this.cata_name,
        },
      });
    },
    changeCatalog(cata_name) {
      this.defaultChoosed = 0;
      const path = this.$route.path;
      const query = this.$route.query; // 这里可以用Vue的方法获取参数，也可以用正则的方法获取url中的参数
      const new_query = { ...query, cata_name };
      this.$router.push({ path, query: new_query });
      this.setCatalogSensors(cata_name)
    },
    changeFilter(defaultChoosed) {
      this.defaultChoosed = defaultChoosed;
    },
    updateTotal(total, plugin_total) {
      this.initServerData = { ...this.initServerData, total, plugin_total };
    },
    setCatalogSensors(cata_name) {
      const activeTab = cata_name ==='资源' ? 'resource' :'plugin'
      this.$sensors.track('event_click', {
        action_position: 'tag_result',
        action_parameter1: 'category',
        action_type: activeTab
      });
    },
  },
  async asyncData({ app, params }) {
    const { tag_name } = params;
    try {
      const [resourseRes, pluginRes] = await Promise.all([
        searchResourceByLabel(tag_name || '', 1, 0, app.$axios),
        searchPluginByLabel(tag_name || '', 1, 0, app.$axios),
      ]);
      let pluginList = [];
      let resourceList = [];
      let total = 0;
      let plugin_total = 0;
      if (resourseRes.code && resourseRes.code === 'OK') {
        resourceList = resourseRes.data || [];
        resourceList.forEach((item) => {
          item.favorite = false;
        });
        total = resourseRes.meta.total;
      }
      if (pluginRes.code && pluginRes.code === 'OK') {
        pluginRes?.data?.forEach((element) => {
          element.loading = false;
        });
        pluginList = pluginRes.data || [];
        pluginList.forEach((item) => {
          item.favorite = false;
          item.is_install = false;
        });
        plugin_total = pluginRes.meta.page.total;
      }
      const initServerData = { resourceList, pluginList, total, plugin_total };
      return {
        initServerData,
      };
    } catch (e) {
      return {};
    }
  },
};
